<template>
  <div class="bookingSource">
    <v-card class="bookingSource_card">
      <div class=" d-flex flex-column justify-space-around pa-8" flat>
        <h4 class="bookingSource_card-title">
          {{ $t('analytics.sources.title') }}
        </h4>
        <div v-for="item in items" :key="item.title" class="mt-7">
          <div class="d-flex justify-space-between">
            <span class="bookingSource_card-text"> {{ item.title }} </span>
            <span class="bookingSource_card-textPourcentage"> {{ item.percent + '%' }} </span>
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on: activationEvents, attrs }">
              <div
                class="bookingSourceBar my-1"
                v-on="activationEvents"
                @mouseover="hover = true"
                @mouseleave="hover = false"
              >
                <div
                  class="bookingSourceBar__value"
                  :style="{
                    width: item.percent + '%'
                  }"
                  :class="{
                    bookingSourceBar__value_variant: hover,
                    bookingSourceBar__value_variant2: attrs['aria-expanded'] === 'true'
                  }"
                ></div>
              </div>
            </template>
            <span class="mr-8"> {{ item.value + " " + item.title }} </span>
            <span> {{ item.percent + '%' }} </span>
          </v-tooltip>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'BookingSource',
  props: {
    items: {
      type: Array
    }
  },
  data() {
    return {
      hover: false
    }
  }
}
</script>
<style scoped lang="scss">
.bookingSource {
  width: 40%;
}
.bookingSource::v-deep .bookingSource_card {
  height: 100%;
  color: var(--v-text-base);
}
.bookingSource_card-title {
  font-size: 18px;
  font-weight: bold;
}

.bookingSource_card-text {
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.011em;
}

.bookingSource_card-textPourcentage {
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
}
.bookingSourceBar::v-deep {
  width: 100%;
  height: 24px;
  border: 1px solid transparent;
  margin: 1rem 0;
  background: #f2f4f6;
  border-radius: 2px;
}

.bookingSourceBar__value::v-deep {
  background: linear-gradient(270deg, #3269e4 0%, rgba(55, 136, 228, 0.6) 100%);
  width: 100%;
  height: 100%;
  opacity: 1;
}

.bookingSourceBar__value_variant::v-deep {
  background: linear-gradient(270deg, #3269e4 0%, rgba(55, 136, 228, 0.9) 0%);
  opacity: 0.5;
}

.bookingSourceBar__value_variant2::v-deep {
  background: linear-gradient(270deg, #3269e4 0%, rgba(55, 136, 228, 0.6) 100%);
  opacity: 1;
}

.v-tooltip__content {
  background: rgba(4, 145, 210, 0.19);
  border: 1px solid #536da8;
  box-sizing: border-box;
  border-radius: 2px;
  color: var(--v-secondary-base);
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 24px;
}
</style>
